<template>
  <div class="image-container">
    <img v-if="!hideBackgroundImage && imagePath" :src="imagePath" class="blurred-image" />
    <img v-image-fall-back="fallBackImagePath" :src="imagePath" class="top-image" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: "AppImage",
  props: {
    imagePath: String,
    fallBackImagePath: String,
    hideBackgroundImage: Boolean,
    alt: String
  }
};
</script>

<style scoped lang="scss">
.image-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
}

.top-image {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.blurred-image {
  position: absolute;
  object-fit: cover;
  top: -10%;
  width: 120%;
  height: 120%;
  filter: blur(20px);
}
</style>
